const PERMISSION_KEY= "personalize:portfolio_sub";
const PAGE_URL = {
    PORTFOLIO_SUB_PAGE: "/admin/personalize/portfolio-sub"
}

export {PERMISSION_KEY, PAGE_URL}

